import Splide from '@splidejs/splide';
import { arrowPath } from './components/carousel';
import resource from './utils/resource';
import listener from './utils/listener';

/**
 * Normalizes slides: converts divs to li elements and adds splide__slide class
 * @param {jQuery} $slides jQuery collection of slides to normalize
 * @returns {jQuery} jQuery collection of normalized li elements
 */
function normalizeSlides($slides) {
  return $slides.map(function () {
    const $slide = $(this);

    if ($slide.is('li')) {
      $slide.addClass('splide__slide');
      return $slide[0];
    }

    // Convert div to li, preserving existing classes
    const originalClass = $slide.attr('class') || '';
    $slide.removeAttr('class').wrap('<li class="splide__slide"></li>');
    const $li = $slide.parent();
    if (originalClass) {
      $li.addClass(originalClass);
    }

    return $li[0];
  });
}

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
function getEinsteinUtils() {
  const einsteinUtils = window.CQuotient;
  if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
    return einsteinUtils;
  }
  return null;
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function fillDomElement(einsteinResponse, $parentElement) {
  const recommender = $parentElement.data('recommender');
  const recommendedProducts = einsteinResponse[recommender].recs;

  if (recommendedProducts && recommendedProducts.length > 0) {
    const template = $parentElement.data('template');
    const swatches = $parentElement.data('swatches');
    const isCategory = $parentElement.data('categoryId');
    const isAnimalLabelVisible = $parentElement.data('isAnimalLabelVisible');
    const displayRatings = $parentElement.data('displayratings');
    let components = [];

    components = recommendedProducts.map(function (recommendedProduct) {
      const tiledefinition = {};

      tiledefinition.template = template;
      tiledefinition.swatches = swatches;
      tiledefinition.isAnimalLabelVisible = isAnimalLabelVisible;
      tiledefinition.isCategory = !!isCategory;
      tiledefinition.displayratings = displayRatings;
      tiledefinition.model = {
        type: 'product',
        id: recommendedProduct.id
      };

      return tiledefinition;
    });

    const url = new URL($parentElement.data('product-load-url'));
    url.searchParams.append('components', JSON.stringify(components));
    url.searchParams.append('limit', $parentElement.data('limit'));
    url.searchParams.append('recommender', recommender);

    $parentElement.find('.experience-slides').html('');

    $.ajax({
      url: url.href,
      type: 'get',
      dataType: 'html',
      success: function (html) {
        if (html.includes('<li')) {
          const initalConfig = { arrowPath: arrowPath };
          const configs = JSON.parse($parentElement.attr('data-splide-config'));
          const slider = new Splide($parentElement[0], { ...initalConfig, ...configs });

          $parentElement.parent().removeClass('veiled');
          let $carouselList = $parentElement.find('.splide__list');
          if (!$carouselList.length) {
            const $listContainer = $parentElement.find('.js-einstein-carousel-list');
            $('<ul class="splide__list d-flex"></ul>').appendTo($listContainer);
            $carouselList = $parentElement.find('.splide__list');
          }
          $carouselList.html(html);
          slider.mount();
          if (window.dataLayer) {
            listener.dataLayerAddToCartHandler();
          }
          $('.fallback-title').addClass('d-none');
          $('.recently-title').removeClass('d-none');
        }
      },
      error: function () {
        $parentElement.parent().addClass('d-none').removeClass('veiled');
        $parentElement.spinner().stop();
      }
    });
  }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
 */
function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
  const recommender = $parentElement.data('recommender');

  const params = {
    userId: einsteinUtils.getCQUserId(),
    cookieId: einsteinUtils.getCQCookieId(),
    ccver: '1.01'
  };

  if (anchorsArray) {
    params.anchors = anchorsArray;
  }

  /**
   * Processes a recommendation responses
   * @param {Object} einsteinResponse cquotient object
   */
  function recommendationsReceived(einsteinResponse) {
    fillDomElement(einsteinResponse, $parentElement);
    $parentElement.spinner().stop();
  }

  if (einsteinUtils.getRecs) {
    einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
  } else {
    einsteinUtils.widgets = einsteinUtils.widgets || [];
    einsteinUtils.widgets.push({
      recommenderName: recommender,
      parameters: params,
      callback: recommendationsReceived
    });
  }
}

/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createProductAnchor($parentElement) {
  return [
    {
      id: $parentElement.data('primaryProductId'),
      sku: $parentElement.data('secondaryProductId'),
      type: $parentElement.data('alternativeGroupType'),
      alt_id: $parentElement.data('alternativeGroupId')
    }
  ];
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
  return [{ id: $parentElement.data('categoryId') }];
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadRecommendations() {
  const einsteinUtils = getEinsteinUtils();
  if (einsteinUtils) {
    const $recommendationTiles = $('.einstein-carousel');
    $recommendationTiles.each(function () {
      const $parentElement = $(this);
      $parentElement.spinner().start();
      if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length) {
        return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
      } else if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length) {
        return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
      }
      $parentElement.spinner().stop();
      return processRecommendationsTile($parentElement, einsteinUtils);
    });
  }
}

export function loadRecommendationsCarousel() {
  const getSlidesCount = ($slider) =>
    $slider.find('.splide__slide, .splide__list > li, .experience-slides > li, .experience-slides > div').length;

  const hideIfEmpty = ($slider) => {
    if ($slider.closest('.experience-einstein-einsteinCarouselCategory').length) return;
    if (getSlidesCount($slider) === 0) {
      $slider.spinner().stop();
      $slider.parent().parent().addClass('d-none').removeClass('veiled');
    } else {
      $slider.parent().parent().removeClass('d-none');
    }
  };

  const initializeSliders = () => {
    const sliders = $('.slider.splide.recommendations:not(.experience-einstein-einsteinCarouselCategory)');
    let initializedCount = 0;

    sliders.each((index, slider) => {
      // check if the slider is already initialized
      if ($(slider).data('splide-initialized')) {
        return;
      }

      // Prepare the slider structure: move slides from experience-slides into splide__list
      const $track = $(slider).find('.splide__track');
      const $experienceSlides = $track.find('.experience-slides');
      let $list = $(slider).find('.splide__list');

      // Create ul.splide__list if it doesn't exist
      if (!$list.length) {
        $('<ul class="splide__list d-flex"></ul>').appendTo($experienceSlides);
        $list = $(slider).find('.splide__list');
      }

      // Move slides from experience-slides into splide__list and convert to <li>
      const $slides =
        $experienceSlides.length && $experienceSlides.children().length ? $experienceSlides.children() : $list.find('.splide__slide');
      if ($slides.length > 0) {
        const $normalizedSlides = normalizeSlides($slides);
        $list.append($normalizedSlides);

        $('.fallback-title').removeClass('d-none');
      } else {
        if ($(slider).closest('.experience-einstein-einsteinCarouselCategory').length) return;

        $(slider).spinner().stop();
        hideIfEmpty($(slider));
        return;
      }

      const initalConfig = { arrowPath: arrowPath };
      const configs = {
        classes: {
          arrows: 'splide__arrows custom-arrows'
        },
        perPage: 4,
        perMove: 1,
        autoplay: true,
        type: 'loop',
        gap: 40,
        pagination: false,
        i18n: {
          prev: resource.msg('button.previous', 'common'),
          next: resource.msg('button.next', 'common')
        },
        padding: { right: '20%' },
        breakpoints: {
          640: {
            perPage: 1,
            gap: 5,
            arrows: true
          },
          1024: {
            perPage: 2,
            gap: 20,
            arrows: true
          }
        }
      };
      const mergedConfig = { ...initalConfig, ...configs };
      const sliderRecommendation = new Splide(slider, mergedConfig);

      sliderRecommendation.mount();
      if (window.dataLayer) {
        listener.dataLayerAddToCartHandler();
      }
      $(slider).data('splide-initialized', true);
      initializedCount++;

      hideIfEmpty($(slider));

      $(slider).spinner().stop();
    });

    return initializedCount;
  };

  initializeSliders();

  const findObserverTarget = () => {
    const selectors = [
      '.related-products',
      '.recommendations-container',
      '.experience-component-einstein-inner',
      '.experience-einstein-carousel',
      '.cart-wrapper',
      '.cart-recommendations',
      '#maincontent',
      '.page'
    ];

    for (let i = 0; i < selectors.length; i++) {
      const target = document.querySelector(selectors[i]);
      if (target) {
        return target;
      }
    }

    const firstSlider = document.querySelector('.slider.splide.recommendations');
    if (firstSlider && firstSlider.parentElement) {
      return firstSlider.parentElement;
    }

    return document.body;
  };

  // Slots can be injected after DOMContentLoaded, so observe a stable page area for late sliders.
  if (window.MutationObserver) {
    const observerTarget = findObserverTarget();
    if (!observerTarget) {
      return;
    }

    let scheduleFrame = null;
    if (window.requestAnimationFrame) {
      scheduleFrame = window.requestAnimationFrame.bind(window);
    } else {
      scheduleFrame = function (callback) {
        return setTimeout(callback, 0);
      };
    }

    let pendingMutations = [];
    let framePending = false;
    let observer = null;

    const processMutations = () => {
      framePending = false;
      let shouldCheck = false;

      pendingMutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Checking if any of the added nodes is a slider
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const hasSliders = $(node).find('.slider.splide.recommendations').length > 0 || $(node).is('.slider.splide.recommendations');
              if (hasSliders) {
                shouldCheck = true;
              }
            }
          });
        }
      });

      pendingMutations = [];

      $('.slider.splide.recommendations').each((index, slider) => {
        if ($(slider).closest('.experience-einstein-einsteinCarouselCategory').length) return;
        hideIfEmpty($(slider));
      });

      if (shouldCheck) {
        const newlyInitialized = initializeSliders();
        if (newlyInitialized > 0 && observer) {
          const stillUninitialized = $('.slider.splide.recommendations:not(.experience-einstein-einsteinCarouselCategory)').filter(
            (_, el) => !$(el).data('splide-initialized')
          ).length;
          if (stillUninitialized === 0) {
            observer.disconnect();
            observer = null;
          }
        }
      }
    };

    observer = new MutationObserver((mutations) => {
      pendingMutations = pendingMutations.concat(mutations);

      if (framePending) {
        return;
      }

      framePending = true;
      scheduleFrame(processMutations);
    });

    observer.observe(observerTarget, {
      childList: true,
      subtree: true
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  loadRecommendations();
  loadRecommendationsCarousel();
});
